import { axiosPost } from '../../axios/axios.js'

export const getObjectAdditionalInfo = {
  methods: {
    checkObjectHasActiveBrigade: async function (requestId, brigadeId, objectId) {
      if (objectId == null) {
        return '' // TODO в случае отсутствия объекта проверять наличие другой бригады вблизи координат, указанных в заявке ?
      }

      const bodyFormData = new FormData()
      bodyFormData.set('objectId', objectId)

      if (requestId) {
        bodyFormData.set('requestId', requestId)
      }

      if (brigadeId) {
        bodyFormData.set('ignoreBrigadeId', brigadeId)
      }

      let continueAssignment = ''

      await axiosPost({
        url: '/service/delta/serviceobject/checkObjectHasActiveBrigade',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          const messages = response.data.result.messages
          if (messages && messages.length !== 0) {
            continueAssignment = messages.join('\n')
          }
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      })

      return continueAssignment
    },
    getAdjacentObjectsRequests: function (requestId, objectId) {
      const bodyFormData = new FormData()
      if (objectId) {
        bodyFormData.set('objectId', objectId)
      }
      if (requestId) {
        bodyFormData.set('requestId', requestId)
      }

      return axiosPost({
        url: '/service/delta/serviceobject/getAdjacentObjectsRequests',
        data: bodyFormData,
        onSuccess: (response) => {
          const requests = response.data.result
          const requestsMap = requests.reduce((map, request) => {
            const key = `${request.objectType} ${request.objectNumber}`

            if (!map[key]) {
              map[key] = []
            }
            map[key].push(request)

            return map
          }, {})
          return Object.entries(requestsMap).map(([key, values]) =>
            `${key}:\n${values.map(v => 'Заявка ' + v.name).join(', ')}`
          )
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      })
    }
  }
}
